import { useState } from 'react'
import { useSelector } from 'react-redux'
import NewWedingModal from './NewWedingModal'
import styles from './NewWedingModal.module.scss'
import ButtonCustom from '../../../components/atoms/button/ButtonCustom'
import Stepper from '../../../components/atoms/Stepper/Stepper'
import { toastHelper } from '../../../util/toastHelper'
import TaskListModal from './TaskListModal'

const types = [
	{ title: 'Ceremony and reception', r: true },
	{ title: 'Ceremony now, reception later', r: false },
	{ title: 'Ceremony, no reception', r: false },
	{ title: 'City hall ceremony and reception', r: true },
	{ title: 'City hall ceremony, no reception', r: false },
	{ title: 'Elopement with reception later', r: false },
	{ title: 'Elopement with no reception', r: false },
	{ title: 'Destination wedding (ceremony and reception)', r: true },
	{
		title: 'Destination wedding (local marriage, destination ceremony and reception)',
		r: true,
	},
	{ title: 'Pop-up wedding (surprise your guests)', r: true },
	{
		title: 'Micro wedding (less than 20 people ceremony and reception)',
		r: true,
	},
	{ title: 'Other', r: true },
]

function Planning({
	open,
	handleClose,
	handleNext,
	handleBack,
	weddingData,
	setWeddingData,
}) {
	const accountType = useSelector((state) => state.auth.accountType)
	const [showTaskList, setShowTaskList] = useState(false)

	const handleNextClick = () => {
		if (!weddingData.type) {
			return toastHelper('Type of wedding is required', 'error')
		}

		// If user is kazoo-planner, show task list modal as next step
		// if (accountType === 'kazoo-planner') {
		// 	setShowTaskList(true)
		// 	// Store that we showed task list so Budget knows to come back here
		// 	setWeddingData({
		// 		...weddingData,
		// 		_showedTaskList: true
		// 	})
		// } else {
			handleNext()
		// }
	}

	const handleTaskListBack = () => {
		setShowTaskList(false)
		// Clear the return flag
		setWeddingData({
			...weddingData,
			_returnToTaskList: false
		})
	}

	const handleTaskListNext = () => {
		setShowTaskList(false)
		// Clear the return flag
		setWeddingData({
			...weddingData,
			_returnToTaskList: false
		})
		handleNext()
	}

	const handleTaskListClose = () => {
		setShowTaskList(false)
		handleClose()
	}

	// If coming back from Budget and we showed task list, show it again
	const shouldShowTaskList = showTaskList || (open && weddingData._showedTaskList && weddingData._returnToTaskList)

	return (
		<>
		<NewWedingModal
			open={open && !shouldShowTaskList}
			handleClose={handleClose}
			handleBack={() => handleBack()}
			modalImage="/images/GuestCount.jpg"
		>
			<div
				className={`${styles.welcomeModal} ${styles.guestCount} ${styles.modalMainContainer}`}
			>
				<div className={styles.welcomeModalBody}>
					<h2>What type of wedding are you planning?</h2>
					<div
						className=""
						style={{ width: '100%', marginTop: '40px' }}
					>
						<div className={styles.modalContainer}>
							<div className={styles.Budget}>
								{types.map((type, idx) => (
									<ButtonCustom
                                        key={idx}
										data-cy={`${type.title}`}
										variant="pilled"
										style={{
											backgroundColor:
												weddingData?.type === type.title
													? '#7ca6bd'
													: '#FFF',
											color:
												weddingData?.type === type.title
													? '#FFF'
													: '#7ca6bd',
										}}
										onClick={() =>
											setWeddingData({
												...weddingData,
												type: type.title,
												reception: type.r,
											})
										}
									>
										{type.title}
									</ButtonCustom>
								))}
							</div>
						</div>
					</div>
				</div>
				<ButtonCustom
					size="lg"
					data-cy="wizard-next"
					onClick={handleNextClick}
				>
					Next
				</ButtonCustom>
				<div className={styles.buttonContainer}>
					<Stepper activeStep={1.2} />
				</div>
			</div>
		</NewWedingModal>
		{/* <TaskListModal
			open={shouldShowTaskList}
			handleClose={handleTaskListClose}
			handleNext={handleTaskListNext}
			handleBack={handleTaskListBack}
			weddingType={weddingData.type}
		/> */}
		</>
	)
}

export default Planning
